import React, { useContext } from 'react';
import {
  Modal as NativeModal,
  StyleProp,
  StyleSheet,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import Icon from 'react-native-easy-icon';
import { ThemeContext } from '../contexts/ThemeContext';

import MuiModal from '@mui/material/Modal';
import { colors } from '../colors/colors';
import { SxProps, Theme } from '@mui/material';
import { SHARED_SVGS } from '../assets';

export enum ModalType {
  NATIVE = 'Native',
  MUI = 'Mui',
}

export interface ModalProps {
  open: boolean;
  onClickClose: () => void;
  modalContent?: JSX.Element;
  customModalStyle?: StyleProp<ViewStyle>;
  customModalCloseButtonStyle?: StyleProp<TextStyle>;
  type?: ModalType;
  customModalTypeStyles?: SxProps<Theme>;
  width?: string;
  height?: string;
  top?: string;
  left?: string;
  paddingVertical?: number;
  paddingHorizontal?: number;
  borderRadius?: number;
}

export const Modal: React.FC<ModalProps> = ({
  open,
  onClickClose,
  modalContent,
  customModalStyle,
  customModalCloseButtonStyle,
  type = ModalType.NATIVE,
  customModalTypeStyles,
  width,
  height,
  top,
  left,
  paddingVertical,
  paddingHorizontal,
  borderRadius,
}) => {
  const currentTheme = useContext(ThemeContext);
  const { theme } = currentTheme;

  return type === ModalType.NATIVE ? (
    <NativeModal
      transparent={true}
      visible={open}
      onRequestClose={onClickClose}
    >
      <View style={styles.modalContainer}>
        <View
          style={[
            styles.modalMain,
            customModalStyle,
            { backgroundColor: theme.dropDown.background },
          ]}
        >
          {modalContent}
          <View
            style={{ ...styles.closeButtonContainer, display: 'flex', gap: 12 }}
          >
            <img
              src={SHARED_SVGS?.CloseIconNew}
              style={{
                cursor: 'pointer',
                color: '#808285',
                ...(customModalCloseButtonStyle as React.CSSProperties),
              }}
              onClick={onClickClose}
              height={20}
              width={20}
              alt="closeIconNew"
            />
          </View>
        </View>
      </View>
    </NativeModal>
  ) : (
    <MuiModal
      sx={{
        width: width || 548,
        height: height || 495,
        top: top || '20%',
        left: left || '35%',
        ...customModalTypeStyles,
      }}
      open={open}
      onClose={onClickClose}
    >
      <View
        style={[
          {
            backgroundColor: colors.zonoWhite.color,
            borderRadius: borderRadius || 10,
            paddingVertical: paddingVertical || 30,
            paddingHorizontal: paddingHorizontal || 40,
          },
          customModalStyle,
        ]}
      >
        <Icon
          onPress={onClickClose}
          type="antdesign"
          name="closecircleo"
          size={25}
          style={{
            color: '#9295A5',
            position: 'absolute',
            right: 13,
            top: 13,
            ...(customModalCloseButtonStyle as object),
          }}
        />
        <View>{modalContent}</View>
      </View>
    </MuiModal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    backgroundColor: 'rgba(0,0,0,0.3)',
  },
  modalMain: {
    minWidth: '10%',
    borderRadius: 10,
    padding: '1%',
    position: 'relative',
  },
  closeButtonContainer: {
    position: 'absolute',
    cursor: 'pointer',
    right: 15,
    top: 15,
  },
});
